module.exports = __webpack_public_path__ + "media/Images/LeafSmall1-ee700a03.svg";